export const domainSuggestions: { [correctDomain: string]: string[] } = {
    'gmail.com': [
        'gamil.com',
        'gmial.com',
        'gmail.con',
        'gmai.com',
        'gmail.co',
        'gmail.cmo',
        'gmial.co',
        'ganil.com',
        'gnial.com',
        'gnail.con',
        'gnai.com',
        'gnail.co',
        'gnail.cmo',
        'gnial.co',
        'gmail.cm',
        'gmali.com',
        'gmall.com',
        'gmil.com',
        'gmil.con',
        'gmil.co',
    ],
    'yahoo.com': [
        'yhoo.com',
        'yahho.com',
        'yaho.com',
        'yaoo.com',
        'yaho.co',
        'yahoom.com',
        'yhaoo.com',
        'yah0o.com' 
    ],
    'hotmail.com': [
        'hotmal.com',
        'hotmial.com',
        'hotmil.com',
        'hotnail.com',
        'hotmail.co',
        'hotamil.com',
        'htomail.com'
    ],
    'outlook.com': [
        'outlok.com',
        'otlook.com',
        'outllok.com',
        'outlok.co',
        'oulook.com',
        'outlook.con',
        'oultook.com'
    ],
    'aol.com': [
        'aol.co',
        'aol.con',
        'aol.cmo',
        'aoll.com'
    ],
    'icloud.com': [
        'icoud.com',
        'iclod.com',
        'icclod.com',
        'icloud.co',
        'icloud.con',
        'iclud.com',
        'icluod.com'
    ],
    'live.com': [
        'lve.com',
        'liv.com',
        'live.co',
        'live.con',
        'liive.com'
    ],
    'mail.com': [
        'mail.co',
        'mial.com',
        'mai.com',
        'maill.com'
    ],
    'zoho.com': [
        'zoh.com',
        'zoho.co',
        'zhoo.com',
        'zoho.con'
    ],
    'yandex.com': [
        'yandx.com',
        'yandex.co',
        'yanex.com',
        'yadnex.com'
    ],
    'protonmail.com': [
        'protonmal.com',
        'protoneail.com',
        'protonmail.co',
        'protonmil.com',
        'protonmail.con'
    ],
    'att.net': [
        'att.con',
        'at.net',
        'attt.net'
    ]
};

/**
 * Checks the provided email against common typo variants and returns a suggestion if a typo is found.
 * @param email The email address to check.
 * @returns A suggestion string if a typo is detected; otherwise, null.
 */
export function checkEmailTypo(email: string): string | null {
    if(!email) return null;
    const parts = email.split('@');
    if (parts.length !== 2) {
        // Return null or handle invalid email format accordingly.
        return null;
    }
    const [localPart, domain] = parts;
    const normalizedDomain = domain.toLowerCase();

    for (const correctDomain in domainSuggestions) {
        if (domainSuggestions[correctDomain].includes(normalizedDomain)) {
            return `Did you mean ${localPart}@${correctDomain}?`;
        }
    }
    return null;
}
